const BACKGROUND_VARIANTS_MAP = [
  {
    selector: '.hero--hub-component-image-with-swiper.hero',
    vars: [['--lazy-gradient-bg-static', '--lazy-gradient-bg']]
  },
  {
    selector: '.hero.hero-floating-metrics-container.hero--dark',
    vars: [
      ['--lazy-gradient-bg-static', '--lazy-gradient-bg'],
      ['--lazy-individual-nav-overlay-static', '--lazy-individual-nav-overlay']
    ]
  },
  {
    selector: '.ai-impact-results',
    vars: [['--lazy-gradient-bg-static', '--lazy-gradient-bg']]
  },
  {
    selector: '.hub-layout-form-with-gradient',
    vars: [['--lazy-gradient-bg-static', '--lazy-gradient-bg']]
  },
  {
    selector: '.hero--hub-gradient-eclipse',
    vars: [['--lazy-gradient-bg-static', '--lazy-gradient-bg']]
  },
  {
    selector: '.iconzdcm-zoom-aic',
    vars: [['--lazy-zoom-aic-bg-static', '--lazy-zoom-aic-bg']]
  },
  {
    selector: '.iconzdcm-zoomhub',
    vars: [['--lazy-zoomhub-bg-static', '--lazy-zoomhub-bg']]
  },
  {
    selector: '.bg-ai-companion, .iconzdcm-ai-companion',
    vars: [['--lazy-ai-companion-bg-static', '--lazy-ai-companion-bg']]
  }
]

export const BACKGROUND_SELECTOR = BACKGROUND_VARIANTS_MAP.map(
  (v) => v.selector
).join(', ')

const toCssUrl = (url) =>
  `url("${url.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}")`

export function applyBackgroundsForElement(el) {
  const style = window.getComputedStyle(el)
  let applied = false

  for (const { selector, vars } of BACKGROUND_VARIANTS_MAP) {
    if (el.matches(selector)) {
      vars.forEach(([source, target]) => {
        const raw = style.getPropertyValue(source).trim()
        if (raw) {
          el.style.setProperty(target, toCssUrl(raw))
          applied = true
        }
      })
    }
  }
  return applied
}
